import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { Coach } from "../../common/models/coach";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { OrganizationMembership } from "../../common/models/organization-membership";
import { Athlete } from "../../common/models/athlete";
import { GuestItemRightsList } from "../../guests/providers/guests-rights";

export class CoachRights {
  public Ready: Promise<boolean> = new Promise<boolean>((resolve, reject) => {});
  private _itemRightsList: CoachItemRightsList | null = null;
  private _screenRightsList: CoachScreenRightList | null = null;
  private _paramsItem: CoachItemRightsParams | null = null;
  private _paramsScreen: CoachScreenRightsParams | null = null;
  private _bestOfItemRight = 10000;
  private _bestOfScreenRight = 10000;
  constructor(private _utils: UtilsProvider) {
    this.setDefault();
  }

  //
  //
  // PUBLIC
  //
  //

  public evaluateItemRight(params: CoachItemRightsParams): void {

    /**
     * Les paramètres reçus contiennent le coach, le user.id
     * et le organizationId. Les droits évalués doivent répondrent
     * à la question : qu'est-ce que je (user.id) peux faire avec
     * ce coach (coach.id) dans cette organisation (organizationId)
     * avec mon rôle (this._bestOfItemRight).
     */

    this._paramsItem = params;
    this.setDefault();
    this.setBestOfRole();

    const coach = this._paramsItem.coach;
    const memberships = this._utils.findManyIn([coach.userId], this._paramsItem.coachMemberships, 'userId');
    const orgIds = this._utils.getKeyValues(memberships, 'organizationId');
    const relations = this._utils.findManyIn([coach.id], this._paramsItem.athleteCoachRelations, 'coachId');

    if (!this._itemRightsList) return;

    switch (this._bestOfItemRight) {
      case OrganizationRole.ID_ADMIN:
        // this._paramsItem.user est un admin
        // tous les coaches
        // on peut supprimer un coach uniquement s'il n'a plus de relation
        this._itemRightsList.view = true;
        this._itemRightsList.edit = true;
        this._itemRightsList.lock = true;
        this._itemRightsList.delete = true;
        this._itemRightsList.changeAthletes = true;
        this._itemRightsList.changeTeams = true;
        this._itemRightsList.sendInvitation = true;
        break;

      case OrganizationRole.ID_SUPERCOACH:
        // this._paramsItem.user est un supercoach
        // tous les coaches de son organisation
        // on peut supprimer un coach uniquement s'il n'a plus de relation
        if (orgIds.indexOf(this._paramsItem.organizationId) > -1) {
          this._itemRightsList.view = true;
          this._itemRightsList.edit = true;
          // tous sauf moi et les super-coach
          this._itemRightsList.lock = !(coach.userId === this._paramsItem.user.id || this._paramsItem.rolesIds.includes(OrganizationRole.ID_SUPERCOACH));
          // tous sauf moi
          this._itemRightsList.delete = !(coach.userId === this._paramsItem.user.id);
          this._itemRightsList.changeAthletes = true;
          this._itemRightsList.changeTeams = true;
          this._itemRightsList.sendInvitation = true;
        }
        break;

      case OrganizationRole.ID_COACH:
        // this._paramsItem.user est un coach
        // uniquement son dashboard / profile
        this._itemRightsList.view = (coach.userId === this._paramsItem.user.id);
        this._itemRightsList.edit = (coach.userId === this._paramsItem.user.id);
        break;

      /**
       * L'athlète ne peut pas voir les coaches :
       * https://app.clickup.com/t/28ftvg
       */
      // case OrganizationRole.ID_ATHLETE:
      //     // this._paramsItem.user est un athlète
      //     // voir le profil d'un des ses coach
      //     const athIds = this._utils.getKeyValues(relations, 'athleteId');
      //     const athletes = this._utils.findManyIn(athIds, this._paramsItem.athletes, 'id');
      //     const userIds = this._utils.getKeyValues(athletes, 'userId');
      //
      //     if (userIds.indexOf(this._paramsItem.user.id) > -1) {
      //         this._itemRightsList.view = true;
      //     }
      //     break;

      case OrganizationRole.ID_GUEST:
        // this._paramsItem.user est un invité
        // idem que le coach mais en lecture seule
        // tous les coaches de son organisation
        if (orgIds.indexOf(this._paramsItem.organizationId) > -1) {
          this._itemRightsList.view = true;
        }
        break;

      default:
      // rien
    }
  }

  public evaluateScreenRights(params: CoachScreenRightsParams): void {

    /**
     * Détermine les droits que l'utilisateur possède
     * pour les commandes générales des écrans.
     */

    this._paramsScreen = params;
    this.setDefault();
    this.setBestOfRole();

    if (!this._screenRightsList) return;
    switch (this._bestOfScreenRight) {
      case OrganizationRole.ID_ADMIN:
        // this._paramsItem.user est un admin
        this._screenRightsList.list = true;
        this._screenRightsList.add = true;
        this._screenRightsList.edit = true;
        this._screenRightsList.delete = true;
        this._screenRightsList.changeSuperCoachFlag = true;
        this._screenRightsList.sendInvitation = true;
        break;

      case OrganizationRole.ID_SUPERCOACH:
        // this._paramsItem.user est un super-coach
        this._screenRightsList.list = true;
        this._screenRightsList.add = true;
        this._screenRightsList.edit = true;
        this._screenRightsList.delete = true;
        this._screenRightsList.changeSuperCoachFlag = true;
        this._screenRightsList.sendInvitation = true;
        break;

      case OrganizationRole.ID_COACH:
        // this._paramsItem.user est un coach
        this._screenRightsList.list = false;
        this._screenRightsList.add = false;
        this._screenRightsList.edit = true;
        this._screenRightsList.delete = false;
        this._screenRightsList.changeSuperCoachFlag = false;
        break;

      /**
       * L'athlète ne peut pas voir les coaches :
       * https://app.clickup.com/t/28ftvg
       */
      // case OrganizationRole.ID_ATHLETE:
      //     // this._paramsItem.user est un athlète
      //     this._screenRightsList.list = true;
      //     this._screenRightsList.add = false;
      //     this._screenRightsList.edit = false;
      //     this._screenRightsList.delete = false;
      //     this._screenRightsList.changeSuperCoachFlag = false;
      //     break;

      case OrganizationRole.ID_GUEST:
        // this._paramsItem.user est un invité
        this._screenRightsList.list = false;
        this._screenRightsList.add = false;
        this._screenRightsList.edit = false;
        this._screenRightsList.delete = false;
        this._screenRightsList.changeSuperCoachFlag = false;
        break;

      default:
      // rien
    }
  }

  public getItemRightsList(): CoachItemRightsList {
    if (!this._itemRightsList) throw new Error('CoachRights.getItemRightsList() : _itemRightsList is null');

    return this._itemRightsList;
  }

  public getScreenRightsList(): CoachScreenRightList {
    if (!this._screenRightsList) throw new Error('CoachRights.getScreenRightsList() : _screenRightsList is null');

    return this._screenRightsList;
  }

  public getItemParams(): CoachItemRightsParams {
    if (!this._paramsItem) throw new Error('CoachRights.getItemParams() : _paramsItem is null');

    return this._paramsItem;
  }

  public getScreenParams(): CoachScreenRightsParams {
    if (!this._paramsScreen) throw new Error('CoachRights.getScreenParams() : _paramsScreen is null');

    return this._paramsScreen;
  }

  public get LIST() {
    if (this._screenRightsList) {
      return this._screenRightsList.list;
    }
    return false;
  }

  public get ADD() {
    if (this._screenRightsList) {
      return this._screenRightsList.add;
    }
    return false;
  }

  public get EDIT() {
    if (this._screenRightsList) {
      return this._screenRightsList.edit;
    }
    return false;
  }

  public get DELETE() {
    if (this._screenRightsList) {
      return this._screenRightsList.delete;
    }
    return false;
  }

  public get CHANGE_SUPERCOACH_FLAG() {
    if (this._screenRightsList) {
      return this._screenRightsList.changeSuperCoachFlag;
    }
    return false;
  }

  public get SEND_INVITATION() {
    if (this._screenRightsList){
      return this._screenRightsList.sendInvitation;
    }
    return false;
  }

  private setDefault(): void {

    this._itemRightsList = {
      view: false,
      edit: false,
      lock: false,
      delete: false,
      changeAthletes: false,
      changeTeams: false,
      sendInvitation: false,
    };

    this._screenRightsList = {
      list: false,
      add: false,
      edit: false,
      delete: false,
      changeSuperCoachFlag: false,
      sendInvitation: false,
    };

    this._bestOfItemRight = 10000;
    this._bestOfScreenRight = 10000;
  }

  private setBestOfRole() {

    if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
      for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
        if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
          this._bestOfItemRight = this._paramsItem.rolesIds[i];
        }
      }
    }

    if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
      for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
        if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
          this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
        }
      }
    }
  }
}

export interface CoachItemRightsList {
  view: boolean;
  edit: boolean;
  lock: boolean;
  delete: boolean;
  changeAthletes: boolean;
  changeTeams: boolean;
  sendInvitation: boolean;
}


const defaultRights: CoachItemRightsList = {
  view: false,
  edit: false,
  delete: false,
  lock: false,
  changeAthletes: false,
  changeTeams: false,
  sendInvitation: false,
};

export function mapUserRightsToCoachRights(userRights: string []): CoachItemRightsList {
  const rights = { ...defaultRights };

  userRights.forEach((right: string) => {
    if (right in rights) {
      rights[right as keyof CoachItemRightsList] = true;
    }
  });

  return rights;
}

export interface CoachScreenRightList {
  list: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
  changeSuperCoachFlag: boolean;
  sendInvitation: boolean;
}

export interface CoachItemRightsParams {
  user: User;
  organizationId: number;
  coach: Coach;
  rolesIds: number[];
  athleteCoachRelations: AthleteCoach[];
  coachMemberships: OrganizationMembership[];
  athletes: Athlete[];
}

export interface CoachScreenRightsParams {
  rolesIds: number[];
}
